import { createDialogFocusTrap } from "../functions/focusTrap";

export const init = () => {
    const burgerBtn = document.querySelector("#mainmenu-open");
    const navbarBtns = document.querySelectorAll(".navbar-nav li .nav-link");
    const body = document.body;
    const flyoutNavButtons = document.querySelectorAll(
        ".flyout-menu .flyout-menu__nav-button",
    );
    const flyout = document.querySelector("nav.flyout-menu");
    const submenuWrapper = document.querySelector(".submenu-wrapper");
    const focustrap = createDialogFocusTrap(flyout);
    let buttonBottoms = [];

    const isMobile = () => window.innerWidth < 992;

    if (!isMobile()) {
        determineFlyoutMinHeight();
    }

    burgerBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (body.classList.contains("menu-open")) {
            closeMenu();
            return;
        }
        openMenu();
    });

    navbarBtns.forEach((btn) => {
        const uid = btn.getAttribute("data-uid");
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            openMenu();
            if (uid) {
                const submenuItem = document.querySelector(
                    `.flyout-menu__list li[data-submenu="${uid}"]`,
                );
                if (submenuItem) {
                    submenuItem
                        .querySelector(".flyout-menu__nav-button")
                        .click();
                }
            }
        });
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && body.classList.contains("menu-open")) {
            closeMenu();
            burgerBtn.focus(); // Return focus to trigger button
        }
    });

    function openMenu() {
        burgerBtn.setAttribute("aria-expanded", "true");
        flyout.classList.add("open");
        body.classList.add("menu-open");
        if (isMobile() && buttonBottoms.length === 0) {
            flyoutNavButtons.forEach((button) => {
                buttonBottoms.push(button.getBoundingClientRect().bottom);
            });
        }
        document.addEventListener("click", clickOutsideMenuListener);
    }

    function closeMenu() {
        body.classList.remove("menu-open");
        burgerBtn.setAttribute("aria-expanded", "false");
        flyout.classList.remove("open");
        deselectAllSubnavItems();
        submenuWrapper.style = "";
        document.removeEventListener("click", clickOutsideMenuListener);
    }

    const clickOutsideMenuListener = (e) => {
        if (!flyout.contains(e.target) && !e.target.closest(".navbar-toggler") && !e.target.closest(".navbar-nav")) {
            closeMenu();
        }
    };

    flyoutNavButtons.forEach((button, index) => {
        button.addEventListener("click", (e) => {
            const submenuId = button.parentElement.getAttribute("data-submenu");
            const submenu = document.querySelector(
                `[data-submenu-target="${submenuId}"]`,
            );
            const isActive = button.parentElement.classList.contains("active");
            if (isActive) {
                button.parentElement.classList.remove("active");
                button.style = "";
                submenu.classList.remove("show");
                // wait a bit to avoid glitch
                setTimeout(() => {
                    submenuWrapper.style = "";
                }, 300);
            } else {
                // Deactivate other active buttons and submenus
                deselectAllSubnavItems();
                // Activate the clicked button and its submenu
                button.parentElement.classList.add("active");
                submenu.classList.add("show");
                const firstLink = submenu.querySelector("a");
                if (firstLink) {
                    setTimeout(() => {
                        firstLink.focus();
                    }, 300);
                }
                if (isMobile()) {
                    const submenuHeight = submenu.offsetHeight;
                    button.style = `margin-bottom: calc(${submenuHeight}px + 3rem)`;
                    submenuWrapper.style = `top: ${buttonBottoms[index] - flyout.getBoundingClientRect().top}px`;
                }
            }
        });
    });

    function deselectAllSubnavItems() {
        flyoutNavButtons.forEach((btn) => {
            btn.parentElement.classList.remove("active");
            btn.style = "";
        });
        document
            .querySelectorAll(".flyout-menu__submenu.show")
            .forEach((sm) => sm.classList.remove("show"));
    }

    window.addEventListener("resize", () => {
        closeMenu();
        updateStickyHeader();
        buttonBottoms = [];
        if (!isMobile()) {
            determineFlyoutMinHeight();
        }
    });

    function updateStickyHeader() {
        if (window.scrollY >= 500) {
            document.body.classList.remove("header-hidden");
            document.body.classList.add("sticky-header");
        } else if (window.scrollY >= 50) {
            document.body.classList.add("header-hidden");
            document.body.classList.remove("sticky-header");
        } else {
            document.body.classList.remove("header-hidden");
        }
    }
    window.addEventListener("scroll", updateStickyHeader);
    updateStickyHeader();

    function determineFlyoutMinHeight() {
        let maxHeight = 0;
        let bumper = 100;
        submenuWrapper
            .querySelectorAll(".submenu-list")
            .forEach((submenuList) => {
                if (submenuList.offsetHeight > maxHeight)
                    maxHeight = submenuList.offsetHeight;
            });
        flyout.style.minHeight = `calc(${maxHeight + bumper}px + var(--header-height))`;
    }
};
